"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAitoEvaluateResults = exports.EvaluateResultsValidators = exports.isWhyProduct = void 0;
const validation_1 = require("../validator/validation");
const isNaN = (0, validation_1.isLiteral)('NaN').or(validation_1.isNumber.which((0, validation_1.satisfiesCondition)(n => Number.isNaN(n))));
const isNumberOrNaN = validation_1.isNumber.or(isNaN);
const isAitoFieldFeature = (0, validation_1.isPartialObjectOf)({
    $p: validation_1.isNumber,
    $why: validation_1.isAny,
    field: validation_1.isString,
    feature: validation_1.isString.or(validation_1.isBoolean).or(isNumberOrNaN),
});
exports.isWhyProduct = (0, validation_1.isObjectOf)({
    factors: (0, validation_1.isArrayOf)(validation_1.isAny),
});
const isAitoEvaluateCase = (0, validation_1.isPartialObjectOf)({
    offset: validation_1.isNaturalNumber,
    testCase: validation_1.isObject,
    accurate: validation_1.isBoolean,
    top: (0, validation_1.optional)(isAitoFieldFeature),
    correct: (0, validation_1.optional)(isAitoFieldFeature),
});
const isAitoBinTopScore = (0, validation_1.isPartialObjectOf)({
    meanScore: isNumberOrNaN,
    maxScore: isNumberOrNaN,
    minScore: isNumberOrNaN,
    accuracy: isNumberOrNaN,
    n: validation_1.isNaturalNumber,
    accurateOffsets: (0, validation_1.optional)((0, validation_1.isArrayOf)(validation_1.isNaturalNumber)),
    errorOffsets: (0, validation_1.optional)((0, validation_1.isArrayOf)(validation_1.isNaturalNumber)),
});
exports.EvaluateResultsValidators = {
    n: validation_1.isNaturalNumber,
    testSamples: validation_1.isNaturalNumber,
    trainSamples: validation_1.isNaturalNumber,
    features: validation_1.isNaturalNumber,
    error: validation_1.isNumber,
    baseError: validation_1.isNumber,
    accuracy: validation_1.isNumber,
    baseAccuracy: isNumberOrNaN,
    accuracyGain: isNumberOrNaN,
    meanRank: isNumberOrNaN,
    baseMeanRank: isNumberOrNaN,
    rankGain: isNumberOrNaN,
    informationGain: isNumberOrNaN,
    mxe: isNumberOrNaN,
    h: isNumberOrNaN,
    geomMeanP: isNumberOrNaN,
    baseGmp: isNumberOrNaN,
    geomMeanLift: isNumberOrNaN,
    cases: (0, validation_1.isSomeOf)(validation_1.isNull, validation_1.isUndefined, (0, validation_1.isArrayOf)(isAitoEvaluateCase)),
};
const EvaluateResultsAdditionalValidators = {
    meanNs: isNumberOrNaN,
    meanUs: isNumberOrNaN,
    meanMs: isNumberOrNaN,
    medianNs: isNumberOrNaN,
    medianUs: isNumberOrNaN,
    medianMs: isNumberOrNaN,
    allNs: (0, validation_1.isArrayOf)(isNumberOrNaN),
    allUs: (0, validation_1.isArrayOf)(isNumberOrNaN),
    allMs: (0, validation_1.isArrayOf)(isNumberOrNaN),
    warmingMs: isNumberOrNaN,
    accurateOffsets: (0, validation_1.isArrayOf)(isNumberOrNaN),
    errorOffsets: (0, validation_1.isArrayOf)(isNumberOrNaN),
    accurateCases: (0, validation_1.isArrayOf)(isAitoEvaluateCase),
    errorCases: (0, validation_1.isArrayOf)(isAitoEvaluateCase),
    alpha_binByTopScore: (0, validation_1.isArrayOf)(isAitoBinTopScore),
};
exports.isAitoEvaluateResults = (0, validation_1.isAllOf)((0, validation_1.isObjectOf)(exports.EvaluateResultsValidators), (0, validation_1.isPartialObjectOf)(EvaluateResultsAdditionalValidators));
//# sourceMappingURL=AitoEvaluateResults.js.map